import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

import { SearchInput } from '../../../../components';

const useStyles = makeStyles(theme => ({
	root: {},
	row: {
		height: '42px',
		display: 'flex',
		alignItems: 'center',
		marginTop: theme.spacing(1)
	},
	spacer: {
		flexGrow: 1
	},
	importButton: {
		marginRight: theme.spacing(1)
	},
	exportButton: {
		marginRight: theme.spacing(1)
	},
	searchInput: {
		marginRight: theme.spacing(1)
	}
}));

const ProductsToolbar = props => {
	const { placeholder, onSearch, showRightButton = true, ...rest } = props;

	const classes = useStyles();

	return (
		<div {...rest} className={clsx(classes.root)}>
			<div className={classes.row}>
				<SearchInput
					className={classes.searchInput}
					placeholder={placeholder}
					onSearch={onSearch}
				/>

				<span className={classes.spacer} />

				{showRightButton ? (
					<NavLink to='/products/create-product'>
						<Button color='primary' variant='contained'>
							新建商品
						</Button>
					</NavLink>
				) : (
					<></>
				)}
			</div>
		</div>
	);
};

ProductsToolbar.propTypes = {
	className: PropTypes.string,
	onSearch: PropTypes.func
};

export default ProductsToolbar;
